/** One browser query cache, shared by the app and its authenticated transport. No durable connection state lives here. */
import { QueryClient } from '@tanstack/react-query'

export const shopifyQueryClient = new QueryClient()

export type ShopifyConnectionRecovery = {
  reconnectUrl: string
  merchantMessage: string
  request: string
  sequence: number
}
export const shopifyConnectionRecoveryKey = (shop: string) => ['shop', shop, 'connection-recovery'] as const

/** Only a later success from the failed operation clears its recovery; unrelated background reads cannot hide it. */
export function settleShopifyConnectionRecovery(
  shop: string,
  request: string,
  sequence: number,
  recovery: Pick<ShopifyConnectionRecovery, 'reconnectUrl' | 'merchantMessage'> | null,
) {
  const key = shopifyConnectionRecoveryKey(shop)
  shopifyQueryClient.setQueryData<ShopifyConnectionRecovery | null>(key, (current) => {
    if (current && current.sequence > sequence) return current
    if (recovery) return { ...recovery, request, sequence }
    if (current?.request === request) return null
    return current ?? null
  })
}
